import React, { useEffect, useState } from 'react'
import { Button, Icon, Tooltip } from 'antd'
import { CheckUserRight } from '../../dashboard/views/DashboardUserWise'
import UserLogsDrawer from './userLogs'
import { adminRightUser } from '../../../components/_utils/appUtils'

const LogsComponents = (props) => {
  let [visible, setVisible] = useState(false)
  let { userData, currentUser, className } = props

  return (
    <CheckUserRight user={currentUser} rightUserType={[...adminRightUser, 'userManager']}>
      <Tooltip title='Login Logs'>
        <a className={`btn ${className}`}
           onClick={() => {
             setVisible(true)
           }}>
          <Icon type={'unordered-list'} />
        </a>
      </Tooltip>
      {visible ?
        <UserLogsDrawer
          visible={visible}
          user={userData}
          onClose={() => setVisible(false)} />
        : null}
    </CheckUserRight>
  )
}
export default LogsComponents
